import React from "react"
import styles from "./styles.scss"
import Reveal from "components/Reveal"

import devices from "images/devices.png"
import handshake from "images/handshake.png"
import laptop from "images/laptop-service.png"

const Service = ({ icon, title, text }) => (
  <div className={styles.serviceContainer}>
    <div className={styles.imageContainer}>
      <img src={icon} className={styles.serviceIcon} alt="service-icon" />
    </div>
    <b className={styles.serviceTitle}>{title}</b>
    <span className={styles.serviceText}>{text}</span>
  </div>
)

const Services = () => (
  <section className={styles.container}>
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        Våra <span className={styles.primaryColor}>tjänster</span>
      </h2>
      <div className={styles.services}>
        <Reveal className={styles.reveal}>
          <Service
            icon={laptop}
            title="Produktutveckling"
            text="Behöver du ett nytt IT-system, en mobilapplikation eller en användarvänlig hemsida? Vi hjälper till från idé och lansering till underhåll och tillväxt."
          />
        </Reveal>
        <Reveal className={styles.reveal}>
          <Service
            icon={handshake}
            title="IT-konsultation"
            text="Med våra kompetenta full stack-utvecklare kan du känna dig trygg med att allt funkar som det ska. Vi är extra bra på Ruby on Rails, React, React Native, flödesoptimering och effektivisering."
          />
        </Reveal>
        <Reveal className={styles.reveal}>
          <Service
            icon={devices}
            title="UI/UX"
            text="Våra interaktionsdesigners tar tillsammans med er fram en design som är såväl användarvänlig som estetiskt tilltalande. Responsivitet och mobilanpassning är en självklarhet."
          />
        </Reveal>
      </div>
    </div>
  </section>
)

export default Services



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Services/index.jsx